module.exports = __webpack_public_path__ + "static/media/gb.b126bb15.jpg";